import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form, Button, Card, Container, Alert } from 'react-bootstrap';
import { FaGoogle } from 'react-icons/fa';
import { login } from '../../redux/slices/authSlice';
import styles from './Auth.module.css';
import { useTranslation } from '../../i18n';

const validationSchema = Yup.object({
  email: Yup.string()
    .email('כתובת דואר אלקטרוני לא תקינה')
    .required('שדה חובה'),
  password: Yup.string()
    .required('שדה חובה')
});

const Login = ({ location = {} }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, token, isAuthenticated } = useSelector(state => state.auth);

  const redirect = location.search ? location.search.split('=')[1] : '/mosads';

  useEffect(() => {
    if (isAuthenticated && token) {
      navigate(redirect);
    }
  }, [isAuthenticated, token, navigate, redirect]);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema,
    onSubmit: async (values) => {
      const result = await dispatch(login(values));
      if (!result.error) {
        navigate(redirect);
      }
    }
  });

  const handleGoogleLogin = async () => {
    // TODO: Implement Google login
  };

  return (
    <Container className={styles.authContainer}>
      <Card className={styles.authCard}>
        <Card.Body>
          <h2 className={styles.authTitle}>{t('ui.auth.loginTitle')}</h2>
          
          {error && (
            <Alert variant="danger" className="mb-4">
              {error}
            </Alert>
          )}

          <Form onSubmit={formik.handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>{t('ui.auth.email')}</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.email && formik.errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>{t('ui.auth.password')}</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.password && formik.errors.password}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.password}
              </Form.Control.Feedback>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 mb-3"
              disabled={loading}
            >
              {loading ? t('ui.auth.loginSubmitting') : t('ui.auth.loginButton')}
            </Button>

            <Button
              variant="outline-danger"
              className="w-100 mb-4"
              onClick={handleGoogleLogin}
              disabled={loading}
            >
              <FaGoogle className="me-2" />
              {t('ui.auth.loginWithGoogle')}
            </Button>

            <div className={styles.authLinks}>
              <Link to="/forgot-password">{t('ui.auth.forgotPassword')}</Link>
              <span className="mx-2">|</span>
              <Link to="/register">{t('ui.auth.registerLink')}</Link>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Login; 